import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { SellOrderStatusBarProps } from '../../../../../SellOrders/SingleSellOrder/SellOrderStatusBar'
import SellTicketStatusBar, { SellTicketStatusBarNew } from '../../../SellTicketStatusBar'
import SellTicketFinishedStepButtons, { SellTicketFinishedStepButtonsNew } from '../SellTicketFinishedStepButtons'

type SellTicketFinishedStepHeaderProps = & SellOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const SellTicketFinishedStepHeaderDecider: React.FC<SellTicketFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellTicketFinishedStepHeaderDefault} NewComponent={SellTicketFinishedStepHeaderNew} {...rest} />
    )
}

const SellTicketFinishedStepHeaderDefault: React.FC<SellTicketFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellTicketStatusBar {...rest} />
            <SellTicketFinishedStepButtons {...rest} />
        </div>
    )
}

const SellTicketFinishedStepHeaderNew: React.FC<SellTicketFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellTicketStatusBarNew {...rest} />
            <SellTicketFinishedStepButtonsNew {...rest} />
        </div>
    )
}

export default SellTicketFinishedStepHeaderDecider